var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("fragment", [
    _c(
      "div",
      { staticClass: "col-12" },
      [
        _c("custom-field", {
          on: {
            "update-dropdown-value": _vm.handleItemsChange,
            editing: _vm.handleEditing,
          },
          model: {
            value: _vm.newField,
            callback: function ($$v) {
              _vm.newField = $$v
            },
            expression: "newField",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-12 d-flex flex-row justify-content-end" },
      [
        _c(
          "simple-button",
          {
            attrs: { "class-name": "mr-2", type: "white" },
            on: { click: _vm.handleCancel },
          },
          [
            _vm._v(
              "\n      " + _vm._s(_vm.$t("global.words.cancel")) + "\n    "
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "simple-button",
          {
            attrs: {
              disabled: _vm.disableSave,
              loading: _vm.saving,
              "loading-succeeded": _vm.savingStatus,
            },
            on: { click: _vm.handleSubmit },
          },
          [_vm._v("\n      " + _vm._s(_vm.$t("global.words.save")) + "\n    ")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }